export const LIST_NAME = `planTemplates`
export const getBasicUrl = planId => `/plans/${planId}/reports/templates`
